import {AuthGuard} from '../../shared/services';
import {DashboardComponent} from './dashboard.component';
import {DashboardResolver} from './dashboard.resolver';
import {Route} from '@angular/router';

export const DashboardRoutes: Route[] = [
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    resolve: {
      data: DashboardResolver
    }
  }
];
